import Enums from 'utils/EnumsManager';

const { INVOICE } = Enums.REDUX_ACTION_TYPE_PREFIX;
const INVOICEINFO = 'INVOICEINFO';

export const SET_INVOICE_NUMBER = `${INVOICE}_${INVOICEINFO}_SET_INVOICE_NUMBER`;
export const SET_FIELD = `${INVOICE}_${INVOICEINFO}_SET_FIELD`;
export const SET_INVOICE_INFO = `${INVOICE}_${INVOICEINFO}_SET_INVOICE_INFO`;



// WEBPACK FOOTER //
// ./src/views/Invoice/flow/invoiceInfo/actionTypes.js